import { formComponents as baseFormComponents } from "@patient-watch/forms";
import {
    AddActionButton,
    BackActionButton,
    CancelActionButton,
    ConfirmActionButton,
    ContinueActionButton,
    DeleteActionButton,
    DoneActionButton,
    DownloadActionButton,
    EditActionButton,
    NextActionButton,
    RetryActionButton,
    SaveActionButton,
    SendActionButton,
    SkipActionButton,
    StopActionButton,
    SubmitActionButton,
} from "./ActionButtons";

/** Webapp form components with localised standard action buttons. */
export const formComponents = {
    ...baseFormComponents,
    AddButton: AddActionButton,
    BackButton: BackActionButton,
    CancelButton: CancelActionButton,
    ConfirmButton: ConfirmActionButton,
    ContinueButton: ContinueActionButton,
    DeleteButton: DeleteActionButton,
    DoneButton: DoneActionButton,
    DownloadButton: DownloadActionButton,
    EditButton: EditActionButton,
    NextButton: NextActionButton,
    RetryButton: RetryActionButton,
    SaveButton: SaveActionButton,
    SendButton: SendActionButton,
    SkipButton: SkipActionButton,
    StopButton: StopActionButton,
    SubmitButton: SubmitActionButton,
};

export {
    AddActionButton,
    BackActionButton,
    CancelActionButton,
    ConfirmActionButton,
    ContinueActionButton,
    DeleteActionButton,
    DoneActionButton,
    DownloadActionButton,
    EditActionButton,
    NextActionButton,
    RetryActionButton,
    SaveActionButton,
    SendActionButton,
    SkipActionButton,
    StopActionButton,
    SubmitActionButton,
    AddActionButton as AddButton,
    BackActionButton as BackButton,
    CancelActionButton as CancelButton,
    ConfirmActionButton as ConfirmButton,
    ContinueActionButton as ContinueButton,
    DeleteActionButton as DeleteButton,
    DoneActionButton as DoneButton,
    DownloadActionButton as DownloadButton,
    EditActionButton as EditButton,
    NextActionButton as NextButton,
    RetryActionButton as RetryButton,
    SaveActionButton as SaveButton,
    SendActionButton as SendButton,
    SkipActionButton as SkipButton,
    StopActionButton as StopButton,
    SubmitActionButton as SubmitButton,
} from "./ActionButtons";
export { useActionCopy, getActionCopy, type ActionCopy } from "./actionCopy";
